var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',{staticClass:"holder"},[_c('h1',[_vm._v(_vm._s(_vm.$t('oauth.wait')))]),_c('p',[_vm._v(_vm._s(_vm.$t('oauth.process')))]),_c('br'),_c('br'),_c('br'),_c('br'),_c('br')])])
}
var staticRenderFns = []

export { render, staticRenderFns }